export class MudancaSenha {
  senhaAtual: string | null
  senhaNova: string | null

  constructor(obj?: any) {
    if (obj) {
      if (obj.senhaAtual) this.senhaAtual = obj.senhaAtual
      if (obj.senhaNova) this.senhaNova = obj.senhaNova
      if (obj.atualSenha) this.senhaAtual = obj.atualSenha
      if (obj.novaSenhaConfirmacao) this.senhaNova = obj.novaSenhaConfirmacao
    }
  }
}